/**
 * @fileoverview
 * @enhanceable
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.UT.PROTO.ActionBase', null, global);
goog.exportSymbol('proto.UT.PROTO.ActionType', null, global);
goog.exportSymbol('proto.UT.PROTO.Condition', null, global);
goog.exportSymbol('proto.UT.PROTO.EntryOnTypes', null, global);
goog.exportSymbol('proto.UT.PROTO.ExecutionDaysType', null, global);
goog.exportSymbol('proto.UT.PROTO.ExitExecutionDays', null, global);
goog.exportSymbol('proto.UT.PROTO.ExitTriggerLevel', null, global);
goog.exportSymbol('proto.UT.PROTO.ExpiryMonthlyOffsetType', null, global);
goog.exportSymbol('proto.UT.PROTO.ExpiryType', null, global);
goog.exportSymbol('proto.UT.PROTO.LegExitTypes', null, global);
goog.exportSymbol('proto.UT.PROTO.MoveSLToCostType', null, global);
goog.exportSymbol('proto.UT.PROTO.MtmCheckType', null, global);
goog.exportSymbol('proto.UT.PROTO.OpenInterestStrikeType', null, global);
goog.exportSymbol('proto.UT.PROTO.OperatorType', null, global);
goog.exportSymbol('proto.UT.PROTO.PortfolioStrategyType', null, global);
goog.exportSymbol('proto.UT.PROTO.PriceType', null, global);
goog.exportSymbol('proto.UT.PROTO.RangeThresholdTypes', null, global);
goog.exportSymbol('proto.UT.PROTO.RangeTypes', null, global);
goog.exportSymbol('proto.UT.PROTO.ReOrderConditionTypes', null, global);
goog.exportSymbol('proto.UT.PROTO.ReOrderType', null, global);
goog.exportSymbol('proto.UT.PROTO.SquareoffType', null, global);
goog.exportSymbol('proto.UT.PROTO.StgType', null, global);
goog.exportSymbol('proto.UT.PROTO.StrikeOperatorType', null, global);
goog.exportSymbol('proto.UT.PROTO.StrikeSelectionType', null, global);
goog.exportSymbol('proto.UT.PROTO.TriggerEventCondition', null, global);
goog.exportSymbol('proto.UT.PROTO.TriggerType', null, global);
goog.exportSymbol('proto.UT.PROTO.UnderlyingType', null, global);
goog.exportSymbol('proto.UT.PROTO.UnderlyingValueTypes', null, global);
goog.exportSymbol('proto.UT.PROTO.WaitToTradeTypes', null, global);
goog.exportSymbol('proto.UT.PROTO.WebApiExchangeSegmentType', null, global);
goog.exportSymbol('proto.UT.PROTO.WebApiModificationReasonType', null, global);
goog.exportSymbol('proto.UT.PROTO.WebApiPortfolioCreationMethod', null, global);
goog.exportSymbol('proto.UT.PROTO.WebApiPositionFilterType', null, global);
goog.exportSymbol('proto.UT.PROTO.WebApiRequest', null, global);
goog.exportSymbol('proto.UT.PROTO.WebApiResponse', null, global);
goog.exportSymbol('proto.UT.PROTO.WebApiStrategyOrderExeType', null, global);
goog.exportSymbol('proto.UT.PROTO.WebApiStrategyResponseType', null, global);
goog.exportSymbol('proto.UT.PROTO.WebApiStrategyRunningType', null, global);
goog.exportSymbol('proto.UT.PROTO.WebApiStrategyType', null, global);
goog.exportSymbol('proto.UT.PROTO.WebApiTerminationReasonType', null, global);
goog.exportSymbol('proto.UT.PROTO.WebApiTransactionType', null, global);
/**
 * @enum {number}
 */
proto.UT.PROTO.WebApiTransactionType = {
  WEBAPITRANSACTIONTYPE_NEW: 0,
  WEBAPITRANSACTIONTYPE_MODIFY: 1,
  WEBAPITRANSACTIONTYPE_CANCEL: 2,
  WEBAPITRANSACTIONTYPE_PAUSE: 3,
  WEBAPITRANSACTIONTYPE_RUN: 4,
  WEBAPITRANSACTIONTYPE_STOP_FOR_TODAY: 5,
  WEBAPITRANSACTIONTYPE_TRIGGER_ENTRY: 6,
  WEBAPITRANSACTIONTYPE_TRIGGER_EXIT: 7,
  WEBAPITRANSACTIONTYPE_MODIFY_LOT_MULTIPLIER: 8,
  WEBAPITRANSACTIONTYPE_FORCE_TERMINATE: 9
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WebApiStrategyResponseType = {
  WEBAPISTRATEGYRESPONSE_SUCCESSFUL: 0,
  WEBAPISTRATEGYRESPONSE_UNSUCCESSFUL: 1,
  WEBAPISTRATEGYRESPONSE_TERMINATE_SUCCESS: 2,
  WEBAPISTRATEGYRESPONSE_TERMINATE_FAILURE: 3,
  WEBAPISTRATEGYRESPONSE_TERMINATE_SQUAREOFF_SUCCESS: 4,
  WEBAPISTRATEGYRESPONSE_TERMINATE_SQUAREOFF_FAILURE: 5,
  WEBAPISTRATEGYRESPONSE_PAUSE_STRATEGY_SUCCESS: 6,
  WEBAPISTRATEGYRESPONSE_PAUSE_STRATEGY_FAILURE: 7,
  WEBAPISTRATEGYRESPONSE_STRATEGY_RUNNING: 8,
  WEBAPISTRATEGYRESPONSE_TERMINATE_SPREAD_BREACHED: 9,
  WEBAPISTRATEGYRESPONSE_ALGO_NOT_ALLOWED: 10,
  WEBAPISTRATEGYRESPONSE_INCREASE_COUNTER: 11,
  WEBAPISTRATEGYRESPONSE_STRATEGY_ALREADY_TERMINATED: 12,
  WEBAPISTRATEGYRESPONSE_STRATEGY_API_NOT_FOUND: 13,
  WEBAPISTRATEGYRESPONSE_CUSTOM: 14,
  WEBAPISTRATEGYRESPONSE_STRATEGY_COMPLETED: 15,
  WEBAPISTRATEGYRESPONSE_STRATEGY_WAIT: 16,
  WEBAPISTRATEGYRESPONSE_DMS_DISCONNECTED: 17,
  WEBAPISTRATEGYRESPONSE_PAUSE_SUCCESSFUL: 18,
  WEBAPISTRATEGYRESPONSE_RUN_SUCCESSFUL: 19,
  WEBAPISTRATEGYRESPONSE_STOP_FOR_TODAY_SUCCESSFUL: 20,
  WEBAPISTRATEGYRESPONSE_STOP_FOR_TODAY_UNSUCCESSFUL: 21,
  WEBAPISTRATEGYRESPONSE_BACKTESTING_IN_PROGRESS: 22,
  WEBAPISTRATEGYRESPONSE_MANUAL_SQOFF_IN_PROGRESS: 23,
  WEBAPISTRATEGYRESPONSE_EXCH_DISCONNECTION_PAUSE: 24,
  WEBAPISTRATEGYRESPONSE_RUN_UNSUCCESSFUL: 25,
  WEBAPISTRATEGYRESPONSE_MODIFY_SUCCESSFUL: 26,
  WEBAPISTRATEGYRESPONSE_MODIFY_UNSUCCESSFUL: 27,
  WEBAPISTRATEGYRESPONSE_LOT_MULTIPLIER_MODIFY_SUCCESS: 28,
  WEBAPISTRATEGYRESPONSE_LOT_MULTIPLIER_MODIFY_FAILURE: 29,
  WEBAPISTRATEGYRESPONSE_FORCE_TERMINATE_SUCCESS: 30,
  WEBAPISTRATEGYRESPONSE_FORCE_TERMINATE_FAILURE: 31,
  WEBAPISTRATEGYRESPONSE_MAX: 32
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WebApiPositionFilterType = {
  WEBAPIPOSITIONFILTERTYPE_DEALER: 0,
  WEBAPIPOSITIONFILTERTYPE_SYMBOL: 1,
  WEBAPIPOSITIONFILTERTYPE_CLIENT: 2,
  WEBAPIPOSITIONFILTERTYPE_BASKET: 3
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WebApiExchangeSegmentType = {
  WEBAPIEXCHANGESEGMENTTYPE_CASH: 0,
  WEBAPIEXCHANGESEGMENTTYPE_FUTURE_AND_OPTION: 1
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WebApiRequest = {
  WEBAPIREQUEST_STRATEGY_LOAD: 0,
  WEBAPIREQUEST_STRATEGY_REQUEST: 1,
  WEBAPIREQUEST_POSITION: 2,
  WEBAPIREQUEST_SQUARE_OFF: 3
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WebApiResponse = {
  WEBAPIRESPONSE_STRATEGY_LOAD: 0,
  WEBAPIRESPONSE_STRATEGY_REQUEST: 1,
  WEBAPIRESPONSE_POSITION: 2,
  WEBAPIRESPONSE_STRATEGY_RESPONSE: 3,
  WEBAPIRESPONSE_MANUAL_SQUARE_OFF: 4
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WebApiStrategyType = {
  WEBAPISTRATEGYTYPE_TI_BASED: 0,
  WEBAPISTRATEGYTYPE_PORTFOLIO_BASED: 1,
  WEBAPISTRATEGYTYPE_GENERIC_ALGO: 2,
  WEBAPISTRATEGYTYPE_STRATEGY_MAX: 3
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WebApiStrategyRunningType = {
  WEBAPISTRATEGYRUNNINGTYPE_LIVE: 0,
  WEBAPISTRATEGYRUNNINGTYPE_PAPERTRADE: 1,
  WEBAPISTRATEGYRUNNINGTYPE_BACKTESTING: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WebApiStrategyOrderExeType = {
  WEBAPISTRATEGYORDEREXETYPE_AUTOMATED: 0,
  WEBAPISTRATEGYORDEREXETYPE_SEMI_AUTOMATED: 1,
  WEBAPISTRATEGYORDEREXETYPE_OFFLINE: 2,
  WEBAPISTRATEGYORDEREXETYPE_EVENT_BASED: 3
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WebApiTerminationReasonType = {
  WEBAPITERMINATIONREASON_AUTO: 0,
  WEBAPITERMINATIONREASON_FRONT_END: 1,
  WEBAPITERMINATIONREASON_DMS_DISCONNECTION: 2,
  WEBAPITERMINATIONREASON_EXCHANGE_DISCONNECTED: 3,
  WEBAPITERMINATIONREASON_AUTO_TIMER_EXPIRED: 4,
  WEBAPITERMINATIONREASON_TP_HIT_RANGE_CONDITION: 5,
  WEBAPITERMINATIONREASON_SL_HIT_RANGE_CONDITION: 6,
  WEBAPITERMINATIONREASON_TP_HIT: 7,
  WEBAPITERMINATIONREASON_SL_HIT: 8,
  WEBAPITERMINATIONREASON_SQUARE_OFF_TIME_BREACHED: 9,
  WEBAPITERMINATIONREASON_NEW_REJECTED: 10,
  WEBAPITERMINATIONREASON_FREEZE_QTY_BREACHED: 11,
  WEBAPITERMINATIONREASON_EXECUTED_SUCCESSFULY: 12,
  WEBAPITERMINATIONREASON_RMS_REJECTED: 13,
  WEBAPITERMINATIONREASON_RETRY_COUNTER_BREACHED: 14,
  WEBAPITERMINATIONREASON_CLIENT_CODE_NOT_FOUND: 15,
  WEBAPITERMINATIONREASON_RMS_OUTCOME_FAILURE: 16,
  WEBAPITERMINATIONREASONTYPE_EXCH_RECONNECTION_TIMER_BREACHED: 17,
  WEBAPITERMINATIONREASONTYPE_LOCKED_PROFIT_HIT: 18,
  WEBAPITERMINATIONREASONTYPE_STG_EXPIRED: 19,
  WEBAPITERMINATIONREASONTYPE_INVALID_EXECUTION_DAY: 20,
  WEBAPITERMINATIONREASON_MAX: 21
};

/**
 * @enum {number}
 */
proto.UT.PROTO.TriggerType = {
  TRIGGERTYPE_CONDITIONAL_ENTRY: 0,
  TRIGGERTYPE_STOP_LOSS_EXIT: 1,
  TRIGGERTYPE_TARGET_PROFIT_EXIT: 2,
  TRIGGERTYPE_CONDITIONAL_EXIT: 3,
  TRIGGERTYPE_STOP_LOSS_REPAIR: 4,
  TRIGGERTYPE_TARGET_PROFIT_REPAIR: 5,
  TRIGGERTYPE_CONDITIONAL_REPAIR: 6,
  TRIGGERTYPE_SQUARE_OFF: 7,
  TRIGGERTYPE_TARGET_PROFIT_RANGE_EXIT: 8,
  TRIGGERTYPE_STOP_LOSS_RANGE_EXIT: 9,
  TRIGGERTYPE_LOCKED_PROFIT_EXIT: 10,
  TRIGGERTYPE_MULTIPLIER_SQUARE_OFF: 11,
  TRIGGERTYPE_FORCE_TERMINATE: 12
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ActionType = {
  ACTIONTYPE_ENTRY: 0,
  ACTIONTYPE_EXIT: 1,
  ACTIONTYPE_REENTRY: 2,
  ACTIONTYPE_REEXECUTION: 3,
  ACTIONTYPE_PAUSE: 4,
  ACTIONTYPE_RESUME: 5,
  ACTIONTYPE_TERMINATE: 6,
  ACTIONTYPE_INVOKE: 7,
  ACTIONTYPE_TRAIL_STOPLOSS: 8,
  ACTIONTYPE_TRAIL_LOCKED_PROFIT: 9,
  ACTIONTYPE_MOVE_SL_TO_COST: 10,
  ACTIONTYPE_ADJUST_STRIKE: 11
};

/**
 * @enum {number}
 */
proto.UT.PROTO.MtmCheckType = {
  MTMCHECKTYPE_NET_PNL_ABSOLUTE: 0,
  MTMCHECKTYPE_NET_PNL_PERCENT: 1,
  MTMCHECKTYPE_UNDERLYING: 2,
  MTMCHECKTYPE_DELTA: 3,
  MTMCHECKTYPE_UNDERLYING_POINTS: 4,
  MTMCHECKTYPE_UNDERLYING_PERCENTAGE: 5,
  MTMCHECKTYPE_POINTS: 6
};

/**
 * @enum {number}
 */
proto.UT.PROTO.PriceType = {
  PRICETYPE_ABS: 0,
  PRICETYPE_PERCENTANGE: 1
};

/**
 * @enum {number}
 */
proto.UT.PROTO.PortfolioStrategyType = {
  PORTFOLIOSTRATEGYTYPE_CUSTOM: 0,
  PORTFOLIOSTRATEGYTYPE_LONG_STRADDLE: 1,
  PORTFOLIOSTRATEGYTYPE_SHORT_STRADDLE: 2,
  PORTFOLIOSTRATEGYTYPE_LONG_STRANGLE: 3,
  PORTFOLIOSTRATEGYTYPE_SHORT_STRANGLE: 4,
  PORTFOLIOSTRATEGYTYPE_LONG_IRON_CONDOR: 5,
  PORTFOLIOSTRATEGYTYPE_SHORT_IRON_CONDOR: 6,
  PORTFOLIOSTRATEGYTYPE_LONG_IRON_BUTTERFLY: 7,
  PORTFOLIOSTRATEGYTYPE_SHORT_IRON_BUTTERFLY: 8,
  PORTFOLIOSTRATEGYTYPE_LONG_CALL_BUTTERFLY: 9,
  PORTFOLIOSTRATEGYTYPE_SHORT_CALL_BUTTERFLY: 10,
  PORTFOLIOSTRATEGYTYPE_LONG_PUT_BUTTERFLY: 11,
  PORTFOLIOSTRATEGYTYPE_SHORT_PUT_BUTTERFLY: 12,
  PORTFOLIOSTRATEGYTYPE_BULL_CALL_SPREAD: 13,
  PORTFOLIOSTRATEGYTYPE_BULL_PUT_SPREAD: 14,
  PORTFOLIOSTRATEGYTYPE_BEAR_CALL_SPREAD: 15,
  PORTFOLIOSTRATEGYTYPE_BEAR_PUT_SPREAD: 16,
  PORTFOLIOSTRATEGYTYPE_LONG_CALL: 17,
  PORTFOLIOSTRATEGYTYPE_SHORT_CALL: 18,
  PORTFOLIOSTRATEGYTYPE_LONG_PUT: 19,
  PORTFOLIOSTRATEGYTYPE_SHORT_PUT: 20
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ExpiryMonthlyOffsetType = {
  EXPIRYMONTHLYOFFSETTYPE_CURRENT: 0,
  EXPIRYMONTHLYOFFSETTYPE_NEXT: 1,
  EXPIRYMONTHLYOFFSETTYPE_FAR: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ExpiryType = {
  EXPIRYTYPE_WEEKLY: 0,
  EXPIRYTYPE_MONTHLY: 1,
  EXPIRYTYPE_BASIC: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.StrikeSelectionType = {
  STRIKESELECTIONTYPE_ATM: 0,
  STRIKESELECTIONTYPE_BASIC: 1,
  STRIKESELECTIONTYPE_PRICE_NEAREST: 2,
  STRIKESELECTIONTYPE_PRICE_ABOVE: 3,
  STRIKESELECTIONTYPE_PRICE_BELOW: 4,
  STRIKESELECTIONTYPE_OI_NEAREST: 5,
  STRIKESELECTIONTYPE_OI: 6,
  STRIKESELECTIONTYPE_PRICE_RANGE: 7,
  STRIKESELECTIONTYPE_SPOT_PERCENTAGE: 8,
  STRIKESELECTIONTYPE_STRADDLE_PERCENT: 9,
  STRIKESELECTIONTYPE_STRADDLE_WIDTH: 10
};

/**
 * @enum {number}
 */
proto.UT.PROTO.StrikeOperatorType = {
  STRIKEOPERATORTYPE_PLUS: 0,
  STRIKEOPERATORTYPE_MINUS: 1
};

/**
 * @enum {number}
 */
proto.UT.PROTO.OpenInterestStrikeType = {
  OPENINTEREST_MAX: 0,
  OPENINTEREST_MAX_1: 1,
  OPENINTEREST_MAX_2: 2,
  OPENINTEREST_CHANGEMAX: 3,
  OPENINTEREST_CHANGEMAX_1: 4,
  OPENINTEREST_CHANGEMAX_2: 5
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ExitExecutionDays = {
  EXITEXECUTIONDAYS_ALL: 0,
  EXITEXECUTIONDAYS_MONDAY: 1,
  EXITEXECUTIONDAYS_TUESDAY: 2,
  EXITEXECUTIONDAYS_WEDDAY: 3,
  EXITEXECUTIONDAYS_THURSDAY: 4,
  EXITEXECUTIONDAYS_FRIDAY: 5,
  EXITEXECUTIONDAYS_SATDAY: 6,
  EXITEXECUTIONDAYS_SUNDAY: 7
};

/**
 * @enum {number}
 */
proto.UT.PROTO.StgType = {
  STGTYPE_UTRADE_ORIGINAL: 0,
  STGTYPE_CUSTOM: 1
};

/**
 * @enum {number}
 */
proto.UT.PROTO.UnderlyingType = {
  UNDERLYINGTYPE_CASH: 0,
  UNDERLYINGTYPE_FUTURE: 1
};

/**
 * @enum {number}
 */
proto.UT.PROTO.SquareoffType = {
  SQUAREOFFTYPE_PARTIAL: 0,
  SQUAREOFFTYPE_COMPLETE: 1
};

/**
 * @enum {number}
 */
proto.UT.PROTO.MoveSLToCostType = {
  MOVESLTOCOSTTYPE_ALL_LEGS: 0,
  MOVESLTOCOSTTYPE_SL_LEGS: 1
};

/**
 * @enum {number}
 */
proto.UT.PROTO.UnderlyingValueTypes = {
  UNDERLYINGVALUETYPES_TARGET_PROFIT: 0,
  UNDERLYINGVALUETYPES_STOP_LOSS: 1,
  UNDERLYINGVALUETYPES_VALUE_MAX: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WaitToTradeTypes = {
  WAITTOTRADETYPES_POINT: 0,
  WAITTOTRADETYPES_PERCENTAGE: 1
};

/**
 * @enum {number}
 */
proto.UT.PROTO.RangeThresholdTypes = {
  RANGETHRESHOLDTYPES_PREMIUM: 0,
  RANGETHRESHOLDTYPES_UNDERLYING: 1
};

/**
 * @enum {number}
 */
proto.UT.PROTO.RangeTypes = {
  RANGETYPES_TIME: 0,
  RANGETYPES_VALUES: 1
};

/**
 * @enum {number}
 */
proto.UT.PROTO.EntryOnTypes = {
  ENTRYONTYPES_HIGH: 0,
  ENTRYONTYPES_LOW: 1,
  ENTRYONTYPES_IN_BETWEEN: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.LegExitTypes = {
  LEGEXITTYPES_NONE: 0,
  LEGEXITTYPES_UNDERLYING: 1,
  LEGEXITTYPES_DELTA: 2,
  LEGEXITTYPES_UNDERLYING_POINTS: 3
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ReOrderConditionTypes = {
  REORDERCONDITIONTYPES_RE_ENTRY: 0,
  REORDERCONDITIONTYPES_RE_EXECUTION: 1,
  REORDERCONDITIONTYPES_DEPENDENT: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.OperatorType = {
  BRACES_OPEN: 0,
  BRACES_CLOSE: 1,
  ADD: 2,
  SUB: 3,
  MUL: 4,
  DIVIDE: 5,
  AND: 6,
  OR: 7,
  GREATER_THAN: 8,
  GREATER_THAN_EQUAL: 9,
  LESS_THAN: 10,
  LESS_THAN_EQUAL: 11,
  EQUAL_TO: 12,
  NOT_EQUAL_TO: 13,
  CROSSES_ABOVE: 14,
  CROSSES_BELOW: 15,
  OPERATORTYPE_VALUE_MAX: 16
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ExecutionDaysType = {
  EXECUTIONDAYSTYPE_WEEK_DAYS: 0,
  EXECUTIONDAYSTYPE_RANGE_BASED: 1,
  EXECUTIONDAYSTYPE_VALUE_MAX: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WebApiPortfolioCreationMethod = {
  INDICATOR_BASED_CREATION: 0,
  CPP_TYPE_CREATION: 1,
  REST_TYPE_CREATION: 2,
  PORTFOLIO_CREATION: 3,
  TVPORTFOLIO_CREATION: 4,
  YML_PORTFOLIO_CREATION: 5,
  TV_YML_PORTFOLIO_CREATION: 6
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ActionBase = {
  ACTIONBASE_LEG: 0,
  ACTIONBASE_STRATEGY: 1,
  ACTIONBASE_PORTFOLIO: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.Condition = {
  CONDITION_MTM: 0,
  CONDITION_TP_MTM: 1,
  CONDITION_SL_MTM: 2,
  CONDITION_OI: 3,
  CONDITION_DELTA: 4,
  CONDITION_INDICATOR: 5,
  CONDITION_TIME: 6,
  CONDITION_DAY: 7,
  CONDITION_DTE: 8
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ReOrderType = {
  REORDERTYPE_ALL_LEGS: 0,
  REORDERTYPE_MAX_SL_LEGS: 1,
  REORDERTYPE_MAX_TP_LEGS: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.ExitTriggerLevel = {
  LEG: 0,
  STRATEGY: 1,
  PORTFOLIO: 2,
  GLOBAL: 3,
  MAX: 4
};

/**
 * @enum {number}
 */
proto.UT.PROTO.TriggerEventCondition = {
  TRIGGEREVENTCONDITION_VALUE_MAX: 0,
  TRIGGEREVENTCONDITION_REORDER: 1
};

/**
 * @enum {number}
 */
proto.UT.PROTO.WebApiModificationReasonType = {
  WEBAPIMODIFICATIONREASONTYPE_LOT_MULTIPLIER: 0,
  WEBAPIMODIFICATIONREASONTYPE_STRATEGY_PARAMS: 1,
  WEBAPIMODIFICATIONREASONTYPE_REORDER_CONDITIONS: 2,
  WEBAPIMODIFICATIONREASONTYPE_ADVANCE_ENTRY_CONDITIONS: 3,
  WEBAPIMODIFICATIONREASONTYPE_ADVANCE_EXIT_CONDITIONS: 4,
  WEBAPIMODIFICATIONREASONTYPE_START_TIME: 5,
  WEBAPIMODIFICATIONREASONTYPE_END_TIME: 6,
  WEBAPIMODIFICATIONREASONTYPE_SQUARE_OFF_TIME: 7
};

goog.object.extend(exports, proto.UT.PROTO);
